<template>
  <div class="user-machine-line-product jt-table">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="isBatch ? $t('user.UserMachineLineProduct.330677-0') : $t('userMachineLineProduct.title')"
      :visible.sync="dialogMachineLineProduct"
      width="80%"
      top="6vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
      custom-class="UserMachineLineProduct"
      v-loading="exportLoading"
      :element-loading-text="$t('user.UserMachineLineProduct.128323-0')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-form label-position="left" v-loading="loading" :element-loading-text="$t('common.loading')" :model="model">
        <!-- 批量配置设备类型选择 -->
        <div
          v-if="isBatch"
          style="
            margin-bottom: 20px;
            padding: 15px;
            background-color: #f8f9fa;
            border-radius: 6px;
            display: flex;
            align-items: center;
            gap: 10px;
          "
        >
          <label style="font-weight: 600; color: #303133">{{ $t("user.UserMachineLineProduct.330677-1") }}</label>
          <el-select
            v-model="selectedEquipmentType"
            :placeholder="$t('user.UserMachineLineProduct.330677-2')"
            :loading="isLoadingEquipmentTypes"
            @change="onEquipmentTypeChange"
            style="width: 200px"
            size="mini"
          >
            <el-option v-for="item in equipmentTypes" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span v-if="selectedEquipmentType" style="color: #909399; font-size: 14px">
            {{ $t("user.UserMachineLineProduct.330677-3") }} {{ model.lineProductList.length }}
          </span>
        </div>

        <el-table
          :span-method="mergeCells"
          :empty-text="$t('common.noData')"
          :data="model.lineProductList"
          max-height="610"
        >
          <el-table-column
            field="aisleNo"
            :label="$t('userMachineLineProduct.aisleNum')"
            fixed="left"
            min-width="95"
            :align="'center'"
          >
            <template v-slot="scope">
              {{ scope.row.aisleNo }}
            </template>
          </el-table-column>
          <!-- 货道排序 -->
          <el-table-column field="sort" :label="$t('adverput.sort')" width="100" :align="'center'">
            <template v-slot="scope">
              <el-input :min="0" type="number" v-model="scope.row.sort" />
            </template>
          </el-table-column>
          <el-table-column field="goodsId" width="240" :align="'center'" :label="$t('userMachineLineProduct.goodsId')">
            <template #default="scope">
              <el-select
                v-model="scope.row.goodsId"
                :no-data-text="$t('common.noData')"
                :no-match-text="$t('common.noData')"
                @clear="clearProduct(scope.row)"
                @change="productChange"
                @focus="productFocus(scope.$index)"
                v-el-select-loadmore="loadMore"
                clearable
                filterable
                remote
                :remote-method="handleFilter"
                :placeholder="$t('userMachineLineProduct.select')"
              >
                <el-option
                  v-for="item in allGoodsList"
                  :key="item.id"
                  :label="`${item.no} - ${item.name}`"
                  :value="item.id"
                />
                <el-option v-if="goodsLoading" :disabled="true" class="loading-option">
                  <span class="loading-text"> <i class="el-icon-loading"></i> loading... </span>
                </el-option>
                <el-option
                  v-if="!goodsLoading && !hasMoreGoods && goodsList.length > 0"
                  :disabled="true"
                  class="loading-option"
                >
                  <span class="loading-text">{{ $t("user.UserMachineLineProduct.470603-0") }}</span>
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            :align="'center'"
            :show-overflow-tooltip="true"
            :label="$t('userMachineLineProduct.image')"
          >
            <template v-slot="scope">
              <el-form-item>
                <el-image
                  style="width: 50px; height: 50px; display: block; margin: auto"
                  :src="scope.row.url"
                  fit="scale-down"
                >
                  <div
                    slot="error"
                    class="image-slot"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 100%;
                      width: 100%;
                      font-size: 20px;
                    "
                  >
                    {{ scope.row.goodsId ? "!" : "?" }}
                  </div>
                </el-image>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            :align="'center'"
            prop="goods.no"
            :label="$t('user.UserMachineLineProduct.091361-0')"
          ></el-table-column>
          <el-table-column width="100" :align="'center'" :label="$t('userMachineLineProduct.productPrice')">
            <template #default="scope">
              <el-form-item>{{ scope.row.goods?.costPrice || "-" }}</el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            field="sellingPrice"
            :label="$t('userMachineLineProduct.sellingPrice')"
            min-width="140"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item :rules="rules.sellingPrice">
                <el-input
                  :disabled="!scope.row.goodsId"
                  v-model.lazy="scope.row.sellingPrice"
                  style="width: 100px; font-weight: bolder; font-size: 15px"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 货道模式税率设置 -->
          <el-table-column
            field="vatRate"
            :label="$t('userMachineLineProduct.vatRateSet')"
            min-width="140"
            :align="'center'"
            v-if="
              userEquipment.config &&
              userEquipment.config.vatRate &&
              userEquipment.config.vatRate.isOpen == 1 &&
              userEquipment.config.vatRate.type == 2
            "
          >
            <template v-slot="scope">
              <el-form-item>
                <div style="display: flex; align-items: center">
                  <el-input
                    :min="0"
                    :max="100"
                    type="number"
                    :disabled="!scope.row.goodsId"
                    v-model.lazy="scope.row.vatRate"
                    style="width: 80px; margin-right: 4px"
                  />
                  <span>%</span>
                </div>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            v-if="userEquipment.config && userEquipment.config.age && userEquipment.config.age.ageRange == 1"
            field="ageNum"
            :label="$t('userMachineLineProduct.age')"
            min-width="140"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item :rules="rules.ageNum">
                <el-input
                  :disabled="!scope.row.goodsId"
                  v-model.lazy="scope.row.ageNum"
                  @focus="focusAge(scope.$index)"
                  style="width: 100px"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            field="maxAllowedStock"
            :label="$t('userMachineLineProduct.maxAllowedStock')"
            min-width="175"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item :rules="rules.maxAllowedStock">
                <el-input :disabled="!scope.row.goodsId" v-model.lazy="scope.row.maxAllowedStock" style="width: 100%" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            field="nocurrentInventoryLevelwStock"
            :label="$t('userMachineLineProduct.currentInventoryLevel')"
            min-width="170"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item :rules="rules.currentInventoryLevel">
                <el-input
                  :disabled="!scope.row.goodsId"
                  v-model.lazy="scope.row.currentInventoryLevel"
                  style="width: 100%"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            field="inventoryAlertCount"
            :label="$t('userMachineLineProduct.inventoryAlertCount')"
            min-width="180"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item :rules="rules.inventoryAlertCount">
                <el-input
                  :disabled="!scope.row.goodsId"
                  v-model.lazy="scope.row.inventoryAlertCount"
                  style="width: 100%"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- {{ $t('user.UserMachineLineProduct.470603-1') }} -->
          <el-table-column
            v-if="!isBatch"
            prop="isMerge"
            :label="$t('user.UserMachineLineProduct.470603-1')"
            min-width="120"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item>
                <template v-if="isShowRelieve(scope.row)">
                  <el-button @click="handleRelieve(scope.row)" type="danger" size="mini">{{
                    $t("userMachineLineProduct.Relieve")
                  }}</el-button>
                </template>
                <el-popover v-else placement="left" width="400" trigger="click" style="padding-bottom: 0">
                  <div style="width: 100%; display: flow-root">
                    <div v-if="selectData.length == 0">{{ $t("user.UserMachineLineProduct.470603-2") }}</div>
                    <div
                      v-for="(items, index) in selectData"
                      :key="index"
                      @click="handleMerge(items, scope.row)"
                      :style="
                        (index + 1) % 5 == 0
                          ? 'width: 17%; margin-bottom: 3%; float: left; text-align: center; line-height: 30px; border-radius: 5px; border: 1px solid #DCDFE6; cursor: pointer;'
                          : 'width: 17%; margin-right: 3%; margin-bottom: 3%; float: left; text-align: center; line-height: 30px; border-radius: 5px; border: 1px solid #DCDFE6; cursor: pointer;'
                      "
                    >
                      {{ items.aisleNo }}
                    </div>
                  </div>
                  <el-button @click="handleSelect(scope.row)" type="primary" size="mini" slot="reference">{{
                    $t("userMachineLineProduct.isMergeSelect")
                  }}</el-button>
                </el-popover>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!isBatch && isShowIsSellLine()"
            prop="isSell"
            :label="$t('user.UserMachineLineProduct.424654-0')"
            min-width="140"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item v-if="isShowRelieve(scope.row)">
                <el-switch
                  v-model="scope.row.isSell"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            prop="faultStatus"
            :label="$t('userMachineLineProduct.isFault2')"
            min-width="140"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item>
                <el-switch
                  v-model="scope.row.faultStatus"
                  :active-value="0"
                  :inactive-value="1"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 商品推荐开关 -->
          <el-table-column
            prop="recommendStatus"
            :label="$t('user.UserMachineLineProduct.470603-3')"
            min-width="160"
            :align="'center'"
          >
            <template v-slot="scope">
              <el-form-item>
                <el-switch
                  v-model="scope.row.recommendStatus"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operate')" width="160" fixed="right" :align="'center'">
            <template v-slot="scope">
              <el-form-item>
                <el-button size="mini" plain :disabled="!scope.row.goodsId" round @click="copy(scope.row)">{{
                  $t("userMachineLineProduct.copy")
                }}</el-button>
                <el-button size="mini" plain round @click="paste(scope.row)">{{
                  $t("userMachineLineProduct.paste")
                }}</el-button>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="!isBatch && model.page.totalSize > 0"
          background
          layout="total, sizes, prev, pager, next"
          :current-page.sync="model.page.pageIndex"
          :total="model.page.totalSize"
          :page-size="model.page.pageSize"
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 150]"
        ></el-pagination>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">{{ $t("common.cancel") }}</el-button>
        <el-button v-if="!isBatch" @click="allPaste" type="success" style="float: left; margin-left: 0" size="small">{{
          $t("userMachineLineProduct.allPaste")
        }}</el-button>
        <el-button
          v-if="!isBatch"
          @click="handlerExportLine"
          type="primary"
          style="float: left; margin-left: 15px"
          size="small"
          :loading="exportLoading"
          >{{ $t("user.UserMachineLineProduct.470603-4") }}</el-button
        >
        <el-button type="primary" :disabled="loadingForm" @click="submitForm()" size="small">{{
          isBatch ? $t("user.UserMachineLineProduct.330677-4") : $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  let localset = [];
  let localpage = 1;
  let yaobaocun = 0;
  export default {
    name: "UserMachineLineProduct",
    props: {
      dialogMachineLineProduct: Boolean,
      userEquipment: Object,
      isBatch: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const sellingPrice = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("userMachineLineProduct.pRetailPrice")));
        } else {
          let reg = new RegExp(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/);
          if (!reg.test(value)) {
            callback(new Error(this.$t("userMachineLineProduct.decimal")));
          }
          callback();
        }
      };
      const age = (rule, value, callback) => {
        let reg = new RegExp(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/);
        if (!reg.test(value)) {
          callback(new Error(this.$t("userMachineLineProduct.decimal")));
        }
        callback();
      };
      const discountPrice = (rule, value, callback) => {
        if (value) {
          let index = rule.field.split(".")[1];
          let price = this.model.lineProductList[index].sellingPrice;
          if (parseFloat(price) <= parseFloat(value)) {
            callback(new Error(this.$t("userMachineLineProduct.big")));
          }
        }
        callback();
      };
      const currentInventoryLevel = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("userMachineLineProduct.rMaxStock")));
        } else {
          let index = rule.field.split(".")[1];
          let maxAllowedStock = this.model.lineProductList[index].maxAllowedStock;
          if (parseInt(value) > parseInt(maxAllowedStock)) {
            callback(new Error(this.$t("userMachineLineProduct.bigStock")));
          }
        }
        callback();
      };
      return {
        loading: false,
        loadingForm: false,
        exportLoading: false,
        model: {
          lineProductList: [],
          page: {
            pageSize: 20,
            pageIndex: 1,
            totalSize: 0
          }
        },
        selectId: "0",
        copyData: "",
        itemKey: "",
        index: 0,
        rules: {
          sellingPrice: {
            required: true,
            validator: sellingPrice,
            trigger: "blur"
          },
          age: {
            required: true,
            validator: age,
            trigger: "change"
          },
          discountPrice: {
            required: true,
            validator: discountPrice,
            trigger: "change"
          },
          maxAllowedStock: {
            required: true,
            message: this.$t("userMachineLineProduct.rMaxStock"),
            trigger: "blur"
          },
          currentInventoryLevel: {
            required: true,
            validator: currentInventoryLevel,
            trigger: "blur"
          },
          inventoryAlertCount: {
            required: true,
            message: this.$t("userMachineLineProduct.rMaxStock"),
            trigger: "blur"
          }
        },
        copyIndex: 10000,
        selectData: [],
        //  模式
        mode: 1,

        MPLoad: false,
        ProductDrawer: false,
        localindex: -1,
        //  mode=2：商品模式-选择货道
        MCargowayList: [],
        MCPage: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        MCSearch: {
          userMachineId: "",
          lineNums: ""
        },
        goodsList: [],
        goodsLoading: false,
        pageNum: 1,
        pageSize: 20,
        searchGoodsName: "",
        goodsLock: true,
        baseGoodsList: [], //基础商品列表 也就是需要回显数据的商品列表
        debounceTimer: null, // 添加防抖计时器
        hasMoreGoods: true, // 添加是否有更多数据的标记

        // 批量配置相关
        equipmentTypes: [], // 设备类型列表
        selectedEquipmentType: null, // 选中的设备类型
        isLoadingEquipmentTypes: false // 是否正在加载设备类型
      };
    },
    computed: {
      allGoodsList() {
        // 合并baseGoodsList和goodsList并去重，保持baseGoodsList在前面
        if (!this.baseGoodsList || !this.goodsList) return [];

        const selectedItem = this.model.lineProductList[this.selectId];
        const selectedGoodsId = selectedItem?.goodsId;

        // 如果正在搜索
        if (this.searchGoodsName) {
          let results = [...this.goodsList]; // 从搜索结果开始
          const selectedGoodsInBase = this.baseGoodsList.find(item => item.id === selectedGoodsId);

          // 如果当前选中项存在于 baseGoodsList 但不在当前搜索结果 goodsList 中，
          // 则将其添加到结果列表的开头，以确保它仍然可见和可选。
          if (selectedGoodsInBase && !results.some(item => item.id === selectedGoodsId)) {
            results.unshift(selectedGoodsInBase);
          }
          return results;
        } else {
          // 非搜索状态，合并基础列表和（可能由 loadMore 加载的）goodsList
          const mergedList = [...this.baseGoodsList];
          const filteredGoodsList = this.goodsList.filter(
            goodsItem => !this.baseGoodsList.some(baseItem => baseItem.id === goodsItem.id)
          );
          return mergedList.concat(filteredGoodsList);
        }
      }
    },
    methods: {
      //合并单元格
      mergeCells({ row, column, rowIndex }) {
        // 只处理isMerge列 只合并货道绑定模式
        if (column.property === "isMerge") {
          // 只处理奇数行
          if (rowIndex % 2 === 0) {
            // 如果当前行有bindNo值
            if (row.bindNo) {
              return {
                rowspan: 2,
                colspan: 1
              };
            }
          } else if (rowIndex % 2 === 1) {
            // 如果上一行有bindNo值,当前行不显示
            const prevRow = this.model.lineProductList[rowIndex - 1];
            if (prevRow && prevRow.bindNo) {
              return {
                rowspan: 0,
                colspan: 0
              };
            }
          }
        }
        return {
          rowspan: 1,
          colspan: 1
        };
      },
      handleRelieve(row) {
        this.$confirm(this.$t("user.UserMachineLineProduct.470603-5"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            let url = this.$url.MachineLineBind.relieve;
            let info = {
              equipmentNo: row.equipmentNo,
              bindNo: row.bindNo
            };
            this.$api
              .request(url, this.$method.put, info)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("userMachineLineProduct.relieveSuccess"));
                  this.openDialog(1);
                }
              })
              .catch(() => {});
          })
          .catch(() => {});
      },
      //展示解除合并
      isShowRelieve(row) {
        return row.bindNo ? true : false;
      },
      // 展示单独售卖咧
      isShowIsSellLine() {
        // return row.bindNo ? false : true;
        if (this.model.lineProductList?.length > 0) {
          return this.model.lineProductList.some(item => item.bindNo);
        }
        return false;
      },
      handleSelect(row) {
        let requestdata = {
          equipmentId: this.userEquipment.id,
          isEnable: this.userEquipment.isEnable,
          isLock: this.userEquipment.isLock,
          lang: this.userEquipment.lang,
          equipmentNo: this.userEquipment.equipmentNo,
          name: this.userEquipment.name
        };
        this.selectData = [];
        this.$api
          .request(this.$url.UserMachine.listProduct, this.$method.get, requestdata)
          .then(res => {
            if (res.code === 0) {
              for (let i = 0; i < res.data.records.length; i++) {
                //货道绑定不展示已绑定货道
                if (res.data.records[i]["bindNo"]) {
                  continue;
                }
                if (row.id != res.data.records[i]["id"]) {
                  this.selectData.push(res.data.records[i]);
                }
              }
            }
          })
          .catch(() => {});
      },
      handleMerge(item, items) {
        let requestdata = {};
        let str = this.$t("user.UserMachineLineProduct.470603-6", [item.aisleNo, items.aisleNo]);
        let url = this.$url.MachineLineBind.bind;
        requestdata = {
          equipmentNo: item.equipmentNo,
          aisleGoodsList: [{ id: item.id }, { id: items.id }]
        };
        this.$confirm(str, this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api
              .request(url, this.$method.put, requestdata)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("userMachineLineProduct.mergeSuccess"));
                  this.openDialog(1);
                } else {
                  this.$message.warning(res.msg);
                }
              })
              .catch(() => {});
          })
          .catch(() => {});
      },

      // 关闭弹窗
      cancel(state, code) {
        this.$emit("lineProductCancel", false, state, code);
      },
      closeDialog() {
        this.copyData = "";
        this.selectId = "";

        // 批量模式下重置额外状态
        if (this.isBatch) {
          this.selectedEquipmentType = null;
          this.equipmentTypes = [];
          this.isLoadingEquipmentTypes = false;
        }

        this.cancel("");
      },

      async openDialog() {
        console.log(this.userEquipment, "userEquipment");
        console.log(this.goodsList, "goodsList");

        if (this.userEquipment.lineProductMode) {
          this.mode = +this.userEquipment.lineProductMode + 1;
        }

        // 重置状态
        localset = [];
        localpage = 1;
        yaobaocun = 0;

        // 重置商品加载状态
        this.pageNum = 1;
        this.goodsList = [];
        this.hasMoreGoods = true;

        // 批量模式下获取设备类型
        if (this.isBatch) {
          await this.getEquipmentTypes();
        } else {
          // 单机模式下直接获取货道数据
          await this.currentChange();
        }
      },
      sizeChange(size) {
        this.model.page.pageIndex = 1;
        this.model.page.pageSize = size;
        localset = [];
        localpage = 1;
        yaobaocun = 0;
        this.currentChange();
      },
      currentChange(pageIndex) {
        if (pageIndex) {
          // 页码切换,把当前页面信息更新到数组
          localset[parseInt(localpage)] = this.model.lineProductList;
          yaobaocun = 0;
        }
        //  获取货道商品信息
        this.loading = true;
        this.model.lineProductList = [];
        this.userEquipment.pageIndex = pageIndex ? pageIndex : this.model.page.pageIndex;
        localpage = this.userEquipment.pageIndex;
        this.userEquipment.pageSize = this.model.page.pageSize;
        // 以前传this,userEquipment
        let requestData = {
          equipmentId: this.userEquipment.id,
          pageIndex: this.userEquipment.pageIndex,
          pageSize: this.userEquipment.pageSize
        };
        this.$api
          .request(this.$url.UserMachine.listProduct, this.$method.get, requestData)
          .then(res => {
            if (res.code === 0) {
              let listLineProducts = res.data.records;
              console.log(listLineProducts, "listLineProducts");

              // 存入基础商品列表
              let baseGoodsArr = [];
              listLineProducts.forEach(item => {
                if (item.goodsId && item.goods) {
                  let bol = baseGoodsArr.some(ite => ite.id === item.goods.id);
                  if (!bol) {
                    baseGoodsArr.push(item.goods);
                  }
                }
              });
              this.baseGoodsList = baseGoodsArr;

              this.model.lineProductList = listLineProducts;
              yaobaocun = localpage;
              this.model.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      copy(row) {
        if (row.goodsId) {
          this.copyData = row;
          this.$message.success(this.$t("userMachineLineProduct.copS"));
        } else {
          this.copyData = null;
          this.$message.warning(this.$t("userMachineLineProduct.lineInfo"));
        }
      },

      paste(row) {
        let index = this.model.lineProductList.findIndex(key => key.aisleNo === row.aisleNo);
        console.log(index);
        if (index > -1) {
          Object.keys(this.copyData).forEach(k => {
            if (k !== "id" && k !== "aisleNo" && k !== "mergeLineNum") {
              this.$set(this.model.lineProductList[index], k, this.copyData[k]);
            }
          });
        }
      },
      allPaste() {
        if (!this.copyData.goodsId) {
          this.$message.warning(this.$t("userMachineLineProduct.one"));
        } else {
          this.model.lineProductList.forEach(k => {
            Object.keys(this.copyData).forEach(ks => {
              if (ks !== "id" && ks !== "aisleNo") {
                this.$set(k, ks, this.copyData[ks]);
              }
            });
          });
        }
      },
      // 清空商品时触发
      clearProduct(row) {
        this.clearRow(row);
      },
      // 选择商品触发事件
      productChange(id) {
        if (!id) return;
        const product = this.goodsList.find(item => item.id === id);
        if (product) {
          this.model.lineProductList[this.selectId].costPrice = product.costPrice;
          this.model.lineProductList[this.selectId].url = product.url;
          this.model.lineProductList[this.selectId].goods = product;
        }
      },
      clearRow(row) {
        row.url = "";
        row.productPrice = "0";
        row.sellingPrice = "0";
        row.age = "0";
        row.discountPrice = "0";
        row.maxAllowedStock = "0";
        row.currentInventoryLevel = "0";
        this.itemKey = Math.random();
      },
      productFocus(index) {
        // 如果切换了不同的下拉框，需要重置搜索条件
        if (this.selectId !== index) {
          this.searchGoodsName = "";
          this.pageNum = 1;
          this.goodsList = [];
          this.hasMoreGoods = true;
        }

        this.selectId = index;

        // 无论是否切换，都确保有数据加载
        if (this.goodsList.length === 0 && this.hasMoreGoods) {
          this.getProducts();
        }
      },
      //  确定提交保存信息
      submitForm() {
        let _self = this;

        // 批量模式额外验证
        if (_self.isBatch) {
          if (!_self.selectedEquipmentType) {
            _self.$message.warning(_self.$t("user.UserMachineLineProduct.330677-8"));
            return;
          }
          if (!_self.userEquipment.equipmentTeamId) {
            _self.$message.warning(_self.$t("user.UserMachineLineProduct.330677-5"));
            return;
          }
          if (!_self.model.lineProductList || _self.model.lineProductList.length === 0) {
            _self.$message.warning(_self.$t("user.UserMachineLineProduct.330677-9"));
            return;
          }
        }

        // 单机模式验证
        if (!_self.isBatch && !_self.valid()) {
          return;
        }

        _self.loadingForm = true;

        let submitData = [];

        // 批量模式：直接使用当前页面数据
        if (_self.isBatch) {
          submitData = _self.model.lineProductList;
        } else {
          // 单机模式：需要合并分页数据
          if (yaobaocun > 0) {
            let lineProductLists = _self.model.lineProductList;
            for (let si = 0; si < lineProductLists.length; si++) {
              submitData.push(lineProductLists[si]);
            }
            if (localset && localset.length > 0) {
              for (let sis = 0; sis < localset.length; sis++) {
                if (sis > 0) {
                  let localsets = localset[sis];
                  if (localsets && localsets.length > 0) {
                    for (let siss = 0; siss < localsets.length; siss++) {
                      submitData.push(localsets[siss]);
                    }
                  }
                }
              }
            }
          } else {
            if (localset && localset.length > 0) {
              for (let sis = 0; sis < localset.length; sis++) {
                if (sis > 0) {
                  let localsets = localset[sis];
                  if (localsets && localsets.length > 0) {
                    for (let siss = 0; siss < localsets.length; siss++) {
                      submitData.push(localsets[siss]);
                    }
                  }
                }
              }
            }
          }
        }

        // 数据处理：age 字段转换
        for (let i = 0; i < submitData.length; i++) {
          if (submitData[i]["ageNum"]) {
            submitData[i]["ageNum"] = parseInt(submitData[i]["ageNum"]);
          }
          // 兼容旧字段名
          if (submitData[i]["age"]) {
            submitData[i]["age"] = parseInt(submitData[i]["age"]);
          }
        }

        // 根据模式确定接口和请求数据
        let url = "";
        let requestData = {};
        if (_self.isBatch) {
          url = _self.$url.BatchConfig.batchConfigLine;
          // 过滤有效的货道商品数据
          let aisleGoodsList = submitData.filter(item => item.goodsId);
          requestData = {
            equipmentTypeId: _self.selectedEquipmentType,
            equipmentTeamId: _self.userEquipment.equipmentTeamId,
            aisleGoodsList: aisleGoodsList
          };
          console.log("批量配置提交数据:", requestData);
        } else {
          url = _self.$url.MachineLineProduct.update;
          requestData = submitData;
        }

        _self.$api
          .request(url, _self.$method.put, requestData)
          .then(res => {
            if (res.code === 0) {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg || (_self.isBatch ? _self.$t("user.UserMachineLineProduct.330677-11") : ""),
                type: "success"
              });
              _self.cancel("");
            } else {
              _self.$message.error(res.msg || (_self.isBatch ? _self.$t("user.UserMachineLineProduct.330677-12") : ""));
            }
            _self.loadingForm = false;
          })
          .catch(() => {
            _self.loadingForm = false;
          });
      },

      //  校验规则
      valid() {
        for (let i = 0; i < this.model.lineProductList.length; i++) {
          let result = this.model.lineProductList[i];
          console.log(result, 111);
          if (result.goodsId) {
            let aisleNo = this.$t("userMachineLineProduct.line").replace("N", result.aisleNo);
            let text = "";
            if (parseInt(result.maxAllowedStock) <= 0) {
              text += this.$t("userMachineLineProduct.vMaxStock");
            } else {
              if (!new RegExp("^[1-9][0-9]{0,2}$").test(result.maxAllowedStock)) {
                text += this.$t("userMachineLineProduct.vMaxStockN");
              }
            }
            if (parseInt(result.currentInventoryLevel) < 0) {
              text += this.$t("userMachineLineProduct.vNowStock");
            } else if (parseInt(result.currentInventoryLevel) != 0) {
              if (!new RegExp("^[1-9][0-9]{0,2}$").test(result.currentInventoryLevel)) {
                text += this.$t("userMachineLineProduct.vNowStockN");
              }
            }
            if (parseInt(result.currentInventoryLevel) > parseInt(result.maxAllowedStock)) {
              text += this.$t("userMachineLineProduct.vNowMax");
            }
            if (parseInt(result.inventoryAlertCount) <= 0) {
              text += this.$t("userMachineLineProduct.vStockAlarm");
            } else {
              if (!new RegExp("^[1-9][0-9]{0,2}$").test(result.inventoryAlertCount)) {
                text += this.$t("userMachineLineProduct.vStockAlarmN");
              }
            }
            if (text && text !== "") {
              this.$message.warning(aisleNo + text);
              return false;
            }
          }
        }
        return true;
      },

      focusAge(e) {
        this.index = e;
      },
      // 点击导出全部货道商品
      handlerExportLine() {
        this.$confirm(
          "Are you sure you want to export all cargo lane information in this device?",
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            this.exportLoading = true;
            this.$api
              .download(this.$url.MachineLineProduct.export, {
                equipmentId: this.userEquipment.id
              })
              .then(res => {
                this.exportLoading = false;
                if (res.code === 0) {
                  this.$message.success("success");
                } else {
                  this.$message.warning(res.msg);
                }
              })
              .catch(() => {
                this.exportLoading = false;
              });
          })
          .catch(err => {
            if (err.msg) {
              this.$message.error(err.msg);
            }
          });
      },
      loadMore() {
        if (!this.goodsLoading && this.hasMoreGoods) {
          this.getProducts();
        }
      },

      handleFilter(query) {
        // 清除上一次的定时器
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.searchGoodsName = query;
          this.pageNum = 1;
          this.goodsList = []; // 清空之前的商品列表
          this.hasMoreGoods = true; // 重置hasMoreGoods状态
          // 在执行搜索时，不清空 baseGoodsList，以保留可能需要回显的原始数据
          this.getProducts();
        }, 300); // 设置 300ms 的防抖延迟
      },

      getProducts() {
        if (!this.goodsLock || !this.hasMoreGoods) return;

        this.goodsLock = false;
        setTimeout(() => (this.goodsLock = true), 300);

        this.goodsLoading = true;
        this.$api
          .request(this.$url.Product.select, this.$method.get, {
            pageIndex: this.pageNum,
            pageSize: this.pageSize,
            searchName: this.searchGoodsName,
            uid: this.userEquipment.uid
          })
          .then(res => {
            if (res.code === 0) {
              const { records } = res.data;
              if (records && records.length) {
                this.pageNum++;
                this.goodsList = [...this.goodsList, ...records];
              } else {
                // 没有更多数据
                this.hasMoreGoods = false;
              }
            }
          })
          .finally(() => {
            this.goodsLoading = false;
          });
      },

      // 批量配置相关方法
      async getEquipmentTypes() {
        if (!this.userEquipment.equipmentTeamId) {
          this.$message.warning(this.$t("user.UserMachineLineProduct.330677-5"));
          return;
        }

        this.isLoadingEquipmentTypes = true;
        try {
          const res = await this.$api.request(this.$url.BatchConfig.getMachineTypeByTeamId, this.$method.get, {
            id: this.userEquipment.equipmentTeamId
          });

          if (res.code === 0) {
            this.equipmentTypes = res.data || [];
            // 重置选择状态
            this.selectedEquipmentType = null;
            this.model.lineProductList = [];
          } else {
            this.$message.error(res.msg || this.$t("user.UserMachineLineProduct.330677-6"));
          }
        } catch (error) {
          this.$message.error(this.$t("user.UserMachineLineProduct.330677-6"));
          console.error(this.$t("user.UserMachineLineProduct.330677-7"), error);
        } finally {
          this.isLoadingEquipmentTypes = false;
        }
      },

      async onEquipmentTypeChange(equipmentTypeId) {
        if (!equipmentTypeId) {
          this.model.lineProductList = [];
          return;
        }

        // 根据设备类型生成货道列表
        const selectedType = this.equipmentTypes.find(type => type.id === equipmentTypeId);
        if (selectedType && selectedType.aisleNum) {
          this.generateAisleList(selectedType.aisleNum);
        }

        // 重置商品相关状态
        this.pageNum = 1;
        this.goodsList = [];
        this.baseGoodsList = [];
        this.hasMoreGoods = true;
      },

      generateAisleList(aisleCount) {
        this.model.lineProductList = [];
        for (let i = 1; i <= aisleCount; i++) {
          this.model.lineProductList.push({
            id: null,
            aisleNo: i,
            goodsId: null,
            goods: null,
            sort: i,
            url: "",
            costPrice: 0,
            sellingPrice: 0,
            vatRate: 0,
            ageNum: 0,
            maxAllowedStock: 0,
            currentInventoryLevel: 0,
            inventoryAlertCount: 0,
            isSell: 1,
            faultStatus: 0,
            recommendStatus: 1,
            bindNo: null
          });
        }

        // 更新分页信息
        this.model.page.totalSize = aisleCount;
        this.model.page.pageIndex = 1;
      }
    },
    directives: {
      "el-select-loadmore": {
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  // 移除 el-form-item 默认的底部外边距，以改善垂直对齐
  ::v-deep .el-table .el-form-item {
    margin-bottom: 0;
  }

  // 确保表格单元格内容垂直居中
  ::v-deep .el-table td .cell {
    display: flex;
    align-items: center; // 垂直居中
    justify-content: center; // 水平居中 (如果需要)
  }

  ::v-deep .cargodrawer {
    .el-drawer__header {
      margin: 20px 20px 0 20px;
      padding: 0 0 20px 0;
      border-bottom: 1px solid #f2f6fc;
    }
    .el-drawer__body {
      padding: 20px;
    }
    .jt-table .el-form-item__content {
      line-height: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-pagination {
      margin: 0.2rem 0;
    }
  }

  ::v-deep .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 15px;
  }

  .el-input-group__prepend {
    padding: 0 10px !important;
  }
  ::v-deep .el-dialog {
    z-index: 9999;
  }
  ::v-deep .UserMachineLineProduct {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: #409eff;
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      height: 660px;
      overflow-y: scroll;
    }
    .el-dialog__footer {
      padding: 20px;
    }
  }
  .UserMachineLineProduct .el-pagination {
    margin-top: 20px;
  }
  ::v-deep .UserMachineLineProduct .el-dialog__footer {
    padding: 20px;
  }
  .el-popover {
    padding-bottom: 0;
  }
  .image-slot {
    width: 34px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    background-color: #f5f7fa;
    color: #909399;
    font-size: 12px;
  }
  .el-table .warning-row {
    background: #f2f6fc;
  }
  .user-machine-line-product .el-switch__core:after {
    width: 24px !important;
    height: 24px !important;
  }
  .user-machine-line-product .el-switch {
    height: 28px !important;
  }
  .user-machine-line-product .el-switch.is-checked .el-switch__core::after {
    margin-left: -25px;
  }
  .user-machine-line-product .el-button--mini,
  .el-button--mini.is-round {
    padding: 8px 15px;
  }
  .loading-option {
    text-align: center;
    padding: 0;
  }
  .loading-text {
    color: #909399;
    i {
      margin-right: 4px;
    }
  }
</style>
